(function (globalScope, factory) {
  var api = factory(globalScope);

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (globalScope) {
    globalScope.theme = globalScope.theme || {};
    globalScope.theme.twoSideCart = api;
  }
})(typeof window !== 'undefined' ? window : null, function (globalScope) {
  'use strict';

  var MAGNETIC_SET_KEY = 'Magnetic Set #';
  var BUNDLE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

  function parseSetNumber(value) {
    var normalized = String(value == null ? '' : value).trim();
    if (!/^[1-9]\d*$/.test(normalized)) return null;

    var parsed = parseInt(normalized, 10);
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function parseMarker(value) {
    if (typeof value !== 'string') return null;

    var parts = value.trim().split(':');
    // com3 (AMPM 3.0) and mset2 (Magnetic Set) share the "Magnetic Set #"
    // counter, so both parent markers feed getNextMagneticSetNumber.
    if (parts[0] !== 'com3' && parts[0] !== 'mset2') return null;
    if (!BUNDLE_ID_PATTERN.test(parts[1] || '')) return null;

    if (parts.length !== 2) return null;
    return {
      bundleId: parts[1],
      role: 'parent'
    };
  }

  function getNextMagneticSetNumber(items) {
    var parentCount = 0;
    var highestNumber = 0;

    (items || []).forEach(function (item) {
      var properties = item && item.properties ? item.properties : {};
      var marker = parseMarker(properties._ikg_bundle);
      if (!marker || marker.role !== 'parent') return;

      parentCount += 1;
      var rawNumber = properties[MAGNETIC_SET_KEY];
      if (rawNumber == null || String(rawNumber).trim() === '') return;

      var setNumber = parseSetNumber(rawNumber);
      if (setNumber == null) {
        throw new Error('An existing magnetic set has an invalid set number.');
      }
      highestNumber = Math.max(highestNumber, setNumber);
    });

    return Math.max(parentCount, highestNumber) + 1;
  }

  function createBundleIdFactory(options) {
    var settings = options || {};
    var counter = 0;

    return function () {
      counter += 1;
      var now = typeof settings.now === 'function' ? settings.now() : Date.now();
      var random = typeof settings.random === 'function' ? settings.random() : Math.random();
      var entropy = Number(random).toString(36).replace(/^0\./, '').slice(0, 8) || '0';
      return [
        'c',
        Math.max(0, Number(now) || 0).toString(36),
        counter.toString(36),
        entropy
      ].join('-').slice(0, 64);
    };
  }

  var createDefaultBundleId = createBundleIdFactory();

  function createBundleId() {
    return createDefaultBundleId();
  }

  function cartRoute(path, rootPath) {
    var root = rootPath;
    if (!root && globalScope && globalScope.Shopify && globalScope.Shopify.routes) {
      root = globalScope.Shopify.routes.root;
    }

    root = String(root || '/').replace(/\/?$/, '/');
    return root + String(path || '').replace(/^\/+/, '');
  }

  return {
    MAGNETIC_SET_KEY: MAGNETIC_SET_KEY,
    parseSetNumber: parseSetNumber,
    parseMarker: parseMarker,
    getNextMagneticSetNumber: getNextMagneticSetNumber,
    createBundleIdFactory: createBundleIdFactory,
    createBundleId: createBundleId,
    cartRoute: cartRoute
  };
});
